import { ReservationState } from '../../enums';
/** OpenAPI description of a ReservationStateQuery query parameter, for ApiPropertyMetadata. */
export const RESERVATION_STATE_QUERY_API_PROPERTY = {
    type: 'string',
    enum: [...Object.values(ReservationState), 'UNREVOKED'],
    description: 'One reservation state, UNREVOKED for every state except CANCELED, or several states by repeating the parameter. Left out, every state counts, CANCELED too.',
};
export const isReservationStateQuery = (value) => {
    return ((typeof value === 'string' &&
        (value === 'UNREVOKED' ||
            Object.values(ReservationState).includes(value))) ||
        (Array.isArray(value) &&
            value.every((item) => Object.values(ReservationState).includes(item))));
};
